import { useCallback, useState } from "react";
import type { ReactNode } from "react";

import {
  DEFAULT_TARGET_LANG,
  type TargetLang,
} from "@bindery/convex/model/language";
import { getPref, setPref, PREF_KEYS } from "@/lib/prefs";
import { TargetLangContext } from "@/components/target-lang-context";

/**
 * Holds the reader's global target language (SPEC "Translation / gloss"),
 * seeded from localStorage and defaulting to `DEFAULT_TARGET_LANG`. Consumed
 * by the gloss popover in phase 6 via `useTargetLang`.
 */
export function TargetLangProvider({ children }: { children: ReactNode }) {
  const [targetLang, setTargetLangState] = useState<TargetLang>(() =>
    getPref(PREF_KEYS.targetLang, DEFAULT_TARGET_LANG),
  );

  const setTargetLang = useCallback((lang: TargetLang) => {
    setTargetLangState(lang);
    setPref(PREF_KEYS.targetLang, lang);
  }, []);

  return (
    <TargetLangContext value={{ targetLang, setTargetLang }}>
      {children}
    </TargetLangContext>
  );
}
